import React, { FormEvent, useEffect, useRef, useState } from "react";
import PaperCard from "../../../components/ui/PaperCard";
import {
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { InputField, InputFieldOTP } from "../../../components/ui/Inputs";
import SelectOptions from "../../../components/ui/SelectOptions";
import {
  PrimaryButton,
  SecondaryButtonText,
} from "../../../components/ui/Button";
import ButtonLoader from "../../../components/ui/ButtonLoader";
import { useForm } from "react-hook-form";
import filterIcon from "./../../../assets/images/icons/filter.png";
import Tables from "../../../components/ui/Tables";
import ModalPopup from "../../../components/ui/ModalPopup";
import BasicDatePicker from "../../../components/ui/BasicDatePicker";
import { Box, color, fontSize, fontWeight } from "@mui/system";
import { formatIndianRupees } from "../../../utils/formatting";
import { RootState } from "./../../../services/redux/store";
import service from "../../../services/api/service";
import { useDispatch, useSelector } from "react-redux";
import postsServices from "../../../services/api/service/postsService";
import Toast from "../../../components/ui/Toast";
import InfoIcon from "./../../../assets/images/icons/info.png";
import { ArrowForward } from "@mui/icons-material";
import {
  authSelector,
  userPermissionSelector,
  userLoanCatSelector,
  userBusinessSelector,
} from "../../../services/redux/slices/authSlice";
import Card from "../../../components/ui/Card";
import dayjs from "dayjs";
import { formatDate, formatISOToDDMMYYYY, parseAndFormatDate } from "../../../utils/dateFormatUtils";
import { filterOptionsWithdraw, messages } from "../../../data/constant";
import LoaderBackdrop from "../../../components/ui/LoaderBackdrop";
import { setStatusPopup } from "../../../services/redux/slices/statusPopupSlice";
import { setUnreadCount } from "../../../services/redux/slices/notificationSlice";
import notificationsServices from "../../../services/api/service/notificationService";
import { encrypt, decrypt } from "../../../utils/crypto";
import MainHeading from "../../../components/ui/MainHeading";
import HeadingLeftRight from "../../../components/ui/HeadingLeftRight";
import CardItemListFlexi from "../../../components/ui/mobile/CardItemListFlexi";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  maskEmail,
  maskMobile,
} from "../../../utils/helpers";
import {
  setSelectedIndex,
} from "../../../services/redux/slices/tabsSlice";
interface FlexiColumn {
  field: string;
  headerName: string;
  width?: number;
  type?: string;
}
export interface RowData {
  [key: string]: string | number | null;
}
interface Option {
  value: string | number;
  label: string | number | React.ReactNode;
}
interface DashboardItemType {
  beneficiaryName: any;
  availLimitAmount: any;
  totalLimit: any;
  availableLimit: any;
  outstanding: any;
  overdueAmount: any;
  overdueBreakup: any;
  overdueTotal: any;
  overDueCharges: any;
  fees: any;
  totalPrincipalOutstanding: any;
  statusOfLoan: any;
}
interface RetrievedData {
  cifNumber?: string | null;
}

interface TableColumn {
  id: string;
  label: string;
  format?: (value: any) => string;
}

const mapColumnsForTable = (columns: FlexiColumn[]): TableColumn[] => {
  return columns.map((col) => ({
    id: col.field,
    label: col.headerName,
    format: (value: any) => {
      if (col.type === "date") return formatDate(value);
      if (col.type === "amount") return formatIndianRupees(Number(value));
      return value || "-";
    },
  }));
};

const Withdraw = () => {
  const { register, handleSubmit, setValue, getValues, watch, reset } =
    useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenOtp, setIsModalOpenOtp] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [overdueAmount, setOverdueAmount] = useState(0);
  const selectedOptionValue = watch("selectedOption");
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOptionFilterValue, setSelectedOptionFilterValue] = useState<
    string | number
  >("");
  const [dashboardData, setDashboardData] = useState<DashboardItemType>();
  const [availableLimit, setAvailableLimit] = useState<number | null>(null);
  const [otp, setOTP] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef<HTMLInputElement[]>(Array(6).fill(null));
  const { userProfile, businessType } = useSelector(authSelector);
  const [inputValue, setInputValue] = useState("");
  const [nagitiveValueCheck, setNagitiveValueCheck] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorMessageOtp, setErrorMessageOtp] = useState<string>("");
  const [disabledButton, setdisabledButton] = useState(false);
  const [accountNumberOptions, setAccountNumberOptions] = useState([]);
  const [accountNumber, setAccountNumber] = useState<string | number>("")
  const { rolePermissions = [] } = useSelector(userPermissionSelector);
  const dispatch = useDispatch();

  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  const handleFilterButtonClick = () => {
    setIsModalOpen(true);
  };

  const filterData = () => {
    fetchData();
    setIsModalOpen(false);
    setSelectedOptionFilterValue("");
    setFromDate(null);
    setToDate(null);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedOptionFilterValue("");
    setFromDate(null);
    setToDate(null);
  };
  const handleCloseModalOtp = () => {
    setIsModalOpenOtp(false);
    setdisabledButton(true);
    setOTP(["", "", "", "", "", ""]);
    setValue("amount", "");
    setIsActive(true);
    setSeconds(180);
    setMessage("");
  };
  // -------------------------------------New Code---------------------------------------
  const selectedLoanNumber = useSelector(
    (state: RootState) => state.dashboardData.selectedLoanNumber
  );

  const selectedIndex = useSelector(
    (state: any) => state?.tabs?.selectedIndex ?? 0
  );
  const userBusinessSelected = useSelector(userBusinessSelector);
  const userLoanCategory = useSelector(userLoanCatSelector);

  const dashboardDataSet = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );

  useEffect(() => {
    const { isValidDate, message } = checkWithdrawal(selectedLoanNumber);
    if(selectedIndex === 1 && isValidDate === true) {
      dispatch(setSelectedIndex(0));
      dispatch(
        setStatusPopup({
          status: "Uh-oh! Withdrawal is on hold!",
          message: message,
        })
      );
      return;
    }
    const matchedObject = dashboardDataSet.find(
      (data: any) => data.loanAccountNumber === selectedLoanNumber
    );
    let data=matchedObject && matchedObject?.beneficiaryName.filter((item: any) => item.disbParty == "CS"); 
    const uniqueData: any = Array.from(
      new Map(data?.map((item: any) => [item.accountNo, item])).values()
    );
    setAccountNumberOptions(
      uniqueData?.map((item: any) => ({
        ...item,
        label: item.accountNo,
        value: item?.accountNo,
      }))
    );
    // let val=data &&  data[data?.length-1];
    setDashboardData(matchedObject);
    setValue("amount", "");
    setValue("acHolderName", "");
    setAccountNumber("");
    setErrorMessage("");
    // setValue("accountNo", val?.accountNo);
    // setValue("acHolderName", val?.acHolderName);
  }, [selectedLoanNumber, selectedIndex]);

  // useEffect(() => {
  //   const matchedObject = dashboardDataSet.find(
  //     (data: any) => data.loanAccountNumber === selectedLoanNumber
  //   );
  //   setDashboardData(matchedObject);
  //   setValue("amount", "");
  //   setErrorMessage("");
  //   setValue("accountNo", dashboardData?.beneficiaryName[0]?.accountNo);
  //   setValue("acHolderName", dashboardData?.beneficiaryName[0]?.acHolderName);
  // }, [setValue, dashboardData]);

  // -------------------------------------New Code---------------------------------------
  const loanAccountNumberOptions: Option[] = useSelector((state: RootState) => {
    const options = state.option.loanAccountNumberOptions;
    if (!options) {
      return [];
    }
    return options.map((item: any) => ({
      value: item,
      label: item,
    }));
  });

  const columns: FlexiColumn[] = [
    {
      field: "created_at",
      headerName: "Request Date",
      type: "date",
    },
    {
      field: "transactionDate",
      headerName: "Transaction date",
      type: "date",
    },
    {
      field: "referenceNo",
      headerName: "Reference no.",
    },
    {
      field: "amount",
      headerName: "Amount",
      type: "amount",
    },
    {
      field: "customerName",
      headerName: "Initiated by",
    },
    {
      field: "beneficiaryAccountNo",
      headerName: "Beneficiary A/c no.",
    },
    {
      field: "status",
      headerName: "Status",
    },
    {
      field: "utr",
      headerName: "UTR",
    },
  ];
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [rows, setRows] = useState<RowData[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [toastOpen, setToastOpen] = useState(false);
  const [severity, setSeverity] = useState<
    "error" | "warning" | "info" | "success"
  >("success");
  const [message, setMessage] = useState("");

  const handleToastClose = () => {
    setToastOpen(false);
  };
  const loanCategoryData: any = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );
  const businessTypeId = useSelector(
    (state: RootState) => state?.auth?.businessType?.id
  );
  // -------------------------------------------------------------------------------------
  const retrievedData = localStorage.getItem("myData");

  const filterLanData = (selectedLoanNumber: string) => {
    const filteredData = dashboardDataSet?.filter((item: any) => {
      if(item.loanAccountNumber === selectedLoanNumber) {
        return item;
      }
    })
    return {
      availableLimit: filteredData[0]?.availableLimit,
      overdueAmount: filteredData[0]?.overdueAmount
    }
  }

  const checkWithdrawal = (loanAccountNumber: any) => {
      let filterLoanAccountNumber = sanctionedDisbursedData?.filter((acc: any) => {
        if (loanAccountNumber === acc.loanAccountNumber) {
          return acc;
        }
      });
  
      const nextRepayDate = new Date(filterLoanAccountNumber?.[0]?.nextRepayDate);
      const nextRepayDay = nextRepayDate.getDate(); // e.g. 19
  
      const currentDate = new Date();
      const currentDay = currentDate.getDate();
  
      const minDay = nextRepayDay - 2; // 19 - 2 = 17
  
      // Returns true only if currentDay falls between nextRepayDay and nextRepayDay - 2
      const isValidDate = currentDay >= minDay && currentDay <= nextRepayDay;
  
      return {
        // message: `Withdrawal requests are restricted between the ${minDay}th to ${nextRepayDay}th of every month. Please try again after the ${nextRepayDay}.`,
        message: `Withdrawal requests are disabled between ${minDay} and ${nextRepayDay} of every month. Please submit your request after your EMI date ${formatISOToDDMMYYYY(nextRepayDate)}.`,
        isValidDate,
      };
    };

  const onSubmit = (data: any) => {
    // Check if there's a pending request first
    if (hasPendingRequest) {
      dispatch(
        setStatusPopup({
          status: "error",
          message:
            "You have a pending withdrawal request. Please wait until it is processed.",
        })
      );
      return;
    }

    setIsActive(true);
    setSeconds(180);
    const formData = getValues();
    setIsLoading(true);
    const { availableLimit, overdueAmount } = filterLanData(selectedLoanNumber);
    let combinedData: any = {
      cif: decrypt(userProfile?.cifNumber),
      cifEntity: decrypt(userProfile?.cifEntity),
      amount: parseInt(formData.amount),
      initiatedBy: parseInt(decrypt(userProfile?.id)),
      availLimitAmount: availableLimit,
      beneficiaryName: formData.acHolderName,
      accountNumber: formData.accountNo,
      availableLimit: availableLimit,
      overdue: overdueAmount,
      lan: selectedLoanNumber,
      business: businessType?.id,
      loanCategory: userLoanCategory?.Flexi[0]?.loanCategoryId,
    };

    // Assuming postsServices is your API service
    postsServices
      .addPost("api/v1/disbursement/request", combinedData)
      .then((response) => {
        setIsLoading(false);
        setReferenceNumber(response?.data?.data?.referenceNumber);
        setIsModalOpenOtp(true);
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          messages.withdrErrorMessages.commonError;
        dispatch(setStatusPopup({ status: "error", message: errorMessage }));
        setIsLoading(false);
      });
  };

  let withdrawData = useSelector((state: RootState) => state.option.loanData);
  useEffect(() => {
    if (withdrawData && withdrawData.length > 0) {
      setAvailableLimit(withdrawData[0].availableLimit);
    }
  }, [withdrawData]);
  const selectedOption = useSelector(
    (state: RootState) => state.option.selectedOption
  );
  const sanctionedDisbursedData = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );
  const [isError, setIsError] = useState(false);
  // Fetch and filter dashboard data based on selectedOption
  useEffect(() => {
    const filteredDashboardData = sanctionedDisbursedData?.filter(
      (item: any) => {
        return item.loanAccountNumber === selectedOption;
      }
    );
    setOverdueAmount(
      filteredDashboardData.length > 0
        ? filteredDashboardData[0].overdueAmount
        : 0
    );

    return () => {};
  }, [sanctionedDisbursedData, selectedOption]);

  // Effect to update dashboard data and overdue amount based on selectedloanAccountNumber
  const selectedloanAccountNumber = useSelector(
    (state: RootState) => state.option.selectedloanAccountNumber
  );
  useEffect(() => {
    const filteredDashboardData = sanctionedDisbursedData?.filter(
      (item: any) => {
        return item.loanAccountNumber === selectedloanAccountNumber;
      }
    );
    setOverdueAmount(
      filteredDashboardData.length > 0
        ? filteredDashboardData[0].overdueAmount
        : 0
    );
  }, [selectedloanAccountNumber]);

  const handleToDateChange = (date: Date | null) => {
    if (date) {
      const toDateDayjs = dayjs(date);
      setToDate(toDateDayjs.toDate());
    } else {
      setToDate(null);
    }
  };
  const fetchData = async () => {
    setIsLoading(true);
    const formattedFromDate = fromDate
      ? dayjs(fromDate).format("YYYY-MM-DD")
      : "";
    const formattedToDate = toDate ? dayjs(toDate).format("YYYY-MM-DD") : "";
    const statusQuery =
      selectedOptionFilterValue === "all"
        ? ""
        : `status=${selectedOptionFilterValue}&`;

    const pageSkip = page + 1; // API might be 1-based indexing
    const pageSize = rowsPerPage;
    const queryString = `?lan=${selectedLoanNumber}&${statusQuery}startDate=${formattedFromDate}&endDate=${formattedToDate}&pageSkip=${pageSkip}&pageSize=${pageSize}`;

    try {
      const response = await service.posts.getPosts(
        `api/v1/disbursement/list${queryString}`
      );
      setRows(response.data.data);
      setTotalRecords(response.data.pagination.total_rows);
    } catch (error) {
      setIsError(true);
      // dispatch(
      //   setStatusPopup({
      //     status: "error",
      //     message: "Something went wrong. Please try again later.",
      //   })
      // );

    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedLoanNumber, page, rowsPerPage]);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    fetchData();
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setdisabledButton(false);
    let checkOverDue = Number(dashboardData?.overdueAmount / 100);
    let checkAvailableLimit = Number(dashboardData?.availableLimit / 100);
    let value = e.target.value.replace(/\D/, "");
    const inputValue: any = e.target.value;
    const numericValue = parseInt(value, 10);
    if (inputValue < 0) {
      e.target.value = "0";
    }
    if (checkOverDue > 1000) {
      setErrorMessage(messages.withdrErrorMessages.overdue);
    } else if (checkAvailableLimit < numericValue && checkOverDue < 100) {
      setErrorMessage(messages.withdrErrorMessages.enterAmountError);
    } else {
      setErrorMessage("");
    }
    setInputValue(value);
    setNagitiveValueCheck(inputValue);
  };
  // otp code
  const handleBackspaceAndEnter = (e: any, index: number) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < setOTP.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };
  const handleOTPChange = (index: number, value: string) => {
    const numericValue = getNumericValue(value);
    const newOTP = [...otp];
    newOTP[index] = numericValue.slice(0, 1);
    setOTP(newOTP);

    if (
      numericValue &&
      index < otp.length - 1 &&
      inputRefs.current[index + 1]
    ) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const getNumericValue = (value: string) => value.replace(/\D/g, "");

  // const accountSummaryData = useSelector(
  //   (state: RootState) => state.accountSummaryData.sanctionedDisbursedData
  // );

  // useEffect(() => {
  //     const initialAccountNumber =
  //       dashboardData[0]?.beneficiaryName[0]?.accountNo ?? "";
  //     const initialAcHolderName =
  //       dashboardData[0]?.beneficiaryName[0]?.acHolderName ?? "";
  //     setValue("accountNo", dashboardData[0]?);
  //     setValue("acHolderName", initialAcHolderName);
  // }, [dashboardData, setValue]);

  const getNotificationsUnreadCounts = async () => {
    try {
      const bodyObj: any = {};
      let cifEntity = userProfile?.cifEntity;
      //bodyObj.cifEntity = cifEntity;
      bodyObj.businessType = encrypt(businessTypeId);
      bodyObj.loanCategory = encrypt(
        loanCategoryData?.TermLoan[0]?.loanCategoryId
      );
      const res = await notificationsServices.getNotifications(bodyObj);
      if (res?.status == 200 && res?.data?.data) {
        dispatch(
          setUnreadCount(res?.data?.pagination?.unreadNotificationsCounts)
        );
      }
    } catch (error) {
      console.error("get notifications API error::", error);
    }
  };

  const handleSubmitOtp = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    const payLoad = {
      id: referenceNumber.toString(),
      otp: otp.join(""),
      business: businessType?.id,
      loanCategory: userLoanCategory?.Flexi[0]?.loanCategoryId,
    };
    postsServices
      .addPost("api/v1/disbursement/otp-verify", payLoad)
      .then((response) => {
        setIsModalOpenOtp(false);
        setIsLoading(false);
        fetchData();
        const successMessage = response?.data?.message || "success";
        setValue("amount", "");
        setMessage("");
        getNotificationsUnreadCounts();
        dispatch(
          setStatusPopup({
            status: "success",
            message: messages.withdrErrorMessages.otpVerify,
          })
        );
        setOTP(["", "", "", "", "", ""]);
      })
      .catch((error) => {
        setIsLoading(false);
        // const errorMessage =
        //   error.response?.data?.message ||
        //   messages.withdrErrorMessages.commonError;
        // setErrorMessageOtp(errorMessage);
      });
  };

  const isComplete = otp.every((val) => val !== "");
  const handleFromDateChange = (date: Date | null) => {
    if (date) {
      const fromDateDayjs = dayjs(date);
      setFromDate(fromDateDayjs.toDate());
    } else {
      setFromDate(null);
    }
  };
  let retrievedData1: RetrievedData[] | null = null;
  if (retrievedData) {
    retrievedData1 = JSON.parse(retrievedData);
  }
  // ------------------------------------Timer---------------------------------
  const [seconds, setSeconds] = useState(180);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    let interval: any = null;
    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      setIsActive(false);
    }

    return () => clearInterval(interval);
  }, [isActive, seconds]);

  const toggleTimer = () => {
    setIsActive(!isActive);
  };
  const resetTimer = () => {
    setSeconds(180); // Reset to 3 minutes
    setIsActive(true); // Restart the timer
    setErrorMessageOtp("");
    setOTP(["", "", "", "", "", ""]);
    setTimeout(() => {
      onSubmit(new Event("submit") as unknown as FormEvent<HTMLFormElement>);
    }, 1000);
  };

  const formatTime = (totalSeconds: any) => {
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  const selectedLoanCategoryObj: any = userLoanCategory?.Flexi?.find(
    (loan: any) => loan?.businessId === userBusinessSelected?.id
  );

  // Add a state to track if any row is pending
  const hasPendingRequest = rows.some((row) => row.status === "pending");

  return (
    <Grid>
      {/* Main Page Heading */}
      {/* <MainHeading title="Withdraw Funds" backButtonVisible={true} /> */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <HeadingLeftRight titleone="Withdrawal Funds" />
          <Box className="dashboard-container">
            <Card>
              <Grid container spacing={2} sx={{ mt: isXsOrSm ? 1 : 0 }}>
                <Grid item xs={6} sm={3} md={3} lg={3}>
                  <Typography className="insidePageLable">
                    Total Limit
                  </Typography>
                  <Typography variant="subtitle1" className="insidePageValue">
                    {" "}
                    {formatIndianRupees(dashboardData?.totalLimit)}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3} lg={3}>
                  <Typography className="insidePageLable">
                    Available Limit
                  </Typography>
                  <Typography variant="subtitle1" className="insidePageValue">
                    {" "}
                    {formatIndianRupees(dashboardData?.availableLimit)}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3} lg={3}>
                  <Typography className="insidePageLable">
                    Principal Outstanding Amount
                  </Typography>
                  <Typography variant="subtitle1" className="insidePageValue">
                    {" "}
                    {formatIndianRupees(
                      dashboardData?.totalPrincipalOutstanding
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3} lg={3}>
                  <Typography className="insidePageLable">Over Due</Typography>
                  <Typography variant="subtitle1" className="insidePageValue">
                    {" "}
                    {formatIndianRupees(dashboardData?.overdueAmount)}
                  </Typography>
                </Grid>
              </Grid>

              {/* Withdraw Form Section */}
              {selectedLoanCategoryObj?.permissionBypass ||
              rolePermissions?.includes("withdraw_request") ? (
                <Box>
                  <Typography mt={"10px"} mb={"10px"}>
                    Please enter below information to Withdrawal fund
                  </Typography>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4}>
                        <Typography mt={"10px"} mb={"10px"}>
                            Amount
                        </Typography>
                        <InputField
                          fullWidth
                          placeholder="Enter amount"
                          {...register("amount")}
                          type="number"
                          autoComplete="off"
                          onChange={handleInputChange}
                          inputProps={{ maxLength: 2 }}
                          error={!!errorMessage}
                          helperText={errorMessage}
                          disabled={
                            dashboardData?.statusOfLoan != "A" || isError
                          }
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Typography mt={"10px"} mb={"10px"}>
                            Account Number
                        </Typography>
                        
                        {/* <InputField
                          placeholder="Enter Account Number"
                          fullWidth
                          {...register("accountNo")}
                          autoComplete="off"
                          inputProps={{ maxLength: 2 }}
                          disabled
                        /> */}
                        <Box>
                          <Select
                            value={accountNumber}
                              onChange={(e: any) => {
                                const value = e.target.value;
                                setAccountNumber(value);
                                setValue("accountNo", value);
                                accountNumberOptions?.map((item: any) => {
                                  if(item?.accountNo === value) {
                                   setValue("acHolderName", item?.acHolderName);
                                   return
                                  }
                                })
                              }}
                              sx={{
                                height: "38px",
                                borderRadius: "6px",
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1CB1B1",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#1CB1B1",
                                },
                                "& .MuiSelect-select": {
                                  padding: "7px 14px 7px 14px !important",
                                  fontSize: "11px",
                                  color: "#a5a3ae",
                                  fontWeight: "400",
                                  textTransform: "capitalize",
                                },
                              }}
                            displayEmpty
                            fullWidth
                            inputProps={{ 'aria-label': 'Without label' }}
                          >
                            <MenuItem value="" disabled>Select Disbursement Account</MenuItem>
                            {accountNumberOptions?.map((item: any) => 
                              <MenuItem value={item?.value} key={item?.value}>{item?.label}</MenuItem>
                            )}
                          </Select>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography mt={"10px"} mb={"10px"}>
                           Beneficiary Name
                        </Typography>
                        <InputField
                          placeholder="Name of beneficiary"
                          fullWidth
                          {...register("acHolderName")}
                          disabled
                          autoComplete="off"
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      spacing={2}
                      sx={{ mt: 2, mb: isXsOrSm ? 2 : 0 }}
                      justifyContent="flex-end"
                    >
                      <Grid
                        item
                        xs={6}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <PrimaryButton
                          type="submit"
                          width="150px"
                          disabled={
                            inputValue.trim() === "" ||
                            parseFloat(nagitiveValueCheck.trim()) <= 0 ||
                            errorMessage.trim() != "" ||
                            disabledButton ||
                            accountNumber?.toString().length === 0
                          }
                        >
                          <ButtonLoader
                            title="Withdrawal"
                            isLoading={isLoading}
                          />
                        </PrimaryButton>
                      </Grid>
                    </Grid>
                  </form>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "20px",
                    gap: "5px",
                    color: "#666666",
                  }}
                >
                  <img src={InfoIcon} alt="Info Icon" />
                  <Typography>
                    {messages.noPermission.section} "Withdraw"
                  </Typography>
                </Box>
              )}
            </Card>
          </Box>
        </Grid>
        {/* Information Section */}
        {/* <Grid item xs={12} sm={4} md={4} lg={4}>
          <CustomCard title="Information related to withdraw" />
          <Box mt={2}>
            <PaperCard>
              <ul className="ul-style" style={{ marginBottom: 0 }}>
                <li>
                  <ListItemText primary="Successfully raised Withdraw requests will be processed in 24 Hours" />
                </li>
                <li>
                  <ListItemText primary="Withdraw request will be validated at Avanse end before taking it for processing. If there any concerns with respect to request, it will be rejected and reason will be informed to customer" />
                </li>
                <li>
                  <ListItemText primary="In case of Overdue, customer will have to clear it first and then only withdraw request will be accepted" />
                </li>
                <li>
                  <ListItemText primary="OTP for withdraw request will be received on registered mobile number of logged in customer" />
                </li>
              </ul>
            </PaperCard>
          </Box>
        </Grid> */}
      </Grid>
      {/* Previous Withdrawal Requests Section */}
      <Grid container marginTop={2}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography
              className="loan-account-main-heading"
              // mb={isXsOrSm ? 2 : 0}
            >
              Previous Withdrawal Requests{" "}
            </Typography>
          </Grid>
          {!isXsOrSm && (
            <Grid item style={{ display: "inline-flex" }} gap={2}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontFamily: "Jost",
                  fontSize: "clamp(9px, 1.2vw, 11px)",
                  fontWeight: "500",
                  lineHeight: "19.36px",
                  textAlign: "left",
                  color: "#00B3B5",
                  width: "fit-content",
                  height: "27px",
                  padding: "14px 12px",
                  borderRadius: "4px",
                  border: "0.5px solid #00B3B5",
                  cursor: "pointer",
                }}
                onClick={handleFilterButtonClick}
              >
                <img
                  src={filterIcon}
                  alt="Filter Icon"
                  style={{ width: "13px", color: "#00B3B5" }}
                />{" "}
                Filter
              </span>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginTop: "20px" }}
          >
            {isXsOrSm ? (
              <CardItemListFlexi columns={columns} rows={rows} />
            ) : (
              <Tables
                columns={mapColumnsForTable(columns)}
                rows={rows}
                page={page}
                isLoading={isLoading}
                rowsPerPage={rowsPerPage}
                totalRecords={totalRecords}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Grid>
        </Grid>
        {/* Filter Modal Popup */}
        <Toast
          open={toastOpen}
          message={message}
          severity={severity}
          onClose={handleToastClose}
        />

        <ModalPopup
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          title="Filter"
          onNavigate={() => {}}
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            padding: "16px 16px 63px 16px",
            margin: "0px",
            borderRadius: "8px 0px 0px 8px",
            height: "100vh",
            width: "340px",
            zIndex: 9999,
          }}
        >
          <SelectOptions
            options={filterOptionsWithdraw}
            label="Select Option"
            isMandatory={false}
            value={selectedOptionFilterValue}
            onChange={(value: string | number) => {
              setSelectedOptionFilterValue(value);
            }}
          />
          <BasicDatePicker
            label="From Date"
            width="100%"
            onChange={handleFromDateChange}
            value={fromDate ? dayjs(fromDate) : null}
          />
          <BasicDatePicker
            label="To date"
            width="100%"
            onChange={handleToDateChange}
            value={toDate ? dayjs(toDate) : null}
          />
          <PrimaryButton
            fullWidth
            type="submit"
            onClick={filterData}
            style={{ margin: "20px 0px" }}
          >
            Apply
          </PrimaryButton>
        </ModalPopup>
        {/* Otp Modal Popup */}
        <ModalPopup
          isOpen={isModalOpenOtp}
          onClose={handleCloseModalOtp}
          title="Enter OTP"
          onNavigate={() => { }}
          style={{ overflowY: 'unset',maxWidth:"500px" }}
        >
          <Divider style={{ padding: "5px 0px" }} />
          <Box className="main-wrapper" mt={5} sx={{overflow: "hidden"}}>
            <form onSubmit={handleSubmitOtp}>
              <Box
                style={{
                  fontSize: isXsOrSm ? "12px" : "14px",
                  fontWeight: "400",
                  color: "#666666",
                  lineHeight: "20.32px",
                  textAlign: "center",
                  marginBottom: "20px",
                }}
              >
                Please enter OTP code which sent to below email
                <span
                  style={{
                    color: "#1CB1B1",
                    marginRight: "5px",
                    marginLeft: "5px",
                    textDecoration: "none",
                    WebkitTextDecorationLine: "none",
                  }}
                >
                  {maskEmail(String(decrypt(userProfile?.email)))}
                </span>
                and mobile number
                <span
                  style={{
                    color: "#1CB1B1",
                    marginRight: "5px",
                    marginLeft: "5px",
                    textDecoration: "none",
                    WebkitTextDecorationLine: "none",
                  }}
                >
                  {maskMobile(String(decrypt(userProfile?.phoneNumber)))}
                </span>
              </Box>
              <Grid
                container
                alignItems="center"
                justifyContent="center"
                spacing={isXsOrSm ? 1 : 2}
                alignContent={"center"}
              >
                {otp.map((value, index) => (
                  <Grid item key={index} xs={2}>
                    <InputFieldOTP
                      required
                      size="small"
                      variant="outlined"
                      type="number"
                      inputMode="decimal"
                      autoComplete="off"
                      value={value}
                      className="otp-style"
                      onChange={(e) => handleOTPChange(index, e.target.value)}
                      onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                      inputProps={{ maxLength: 1 }}
                      inputRef={(el) =>
                        (inputRefs.current[index] = el as HTMLInputElement)
                      }
                      style={{
                        padding: "12px, 16px, 12px, 12px",
                        border: "2px solid #E6E6E6",
                        borderRadius: "8px",
                        minWidth:isXsOrSm?"37px":"45px",
                        width:isXsOrSm?"37px":"52px",
                      }}
                    />
                  </Grid>
                ))}
                <p
                  style={{
                    fontSize: "12px",
                    color: "#d32f2f",
                    fontWeight: "400",
                    textAlign: "left",
                    marginTop: "10px",
                    width: "93%",
                  }}
                >
                  {errorMessageOtp}
                </p>
              </Grid>
              <Grid container>
                <Grid xs={12} sm={12} md={12} lg={12}>
                  <div
                    className="otp-timer"
                    style={{
                      fontSize: "16px",
                      color: "#666",
                      fontWeight: "500",
                    }}
                  >
                    <span>{formatTime(seconds)}</span>
                    <div style={{ float: "right" }}>
                      {!isActive && seconds === 0 ? (
                        <SecondaryButtonText onClick={resetTimer}>
                          {" "}
                          Resend OTP{" "}
                        </SecondaryButtonText>
                      ) : (
                        <span
                          style={{
                            marginLeft: "20px",
                            fontSize: "0.78rem !important",
                            color: "rgb(179, 179, 179)",
                            fontWeight: "500",
                            padding: "0px",
                          }}
                        >
                          Resend OTP
                        </span>
                      )}
                    </div>
                  </div>
                </Grid>
              </Grid>
              <PrimaryButton
                sx={{
                  mt: 5,
                }}
                type="submit"
                fullWidth
                endIcon={<ArrowForward color="inherit" fontSize="small" />}
                disabled={!isComplete}
              >
                Submit
              </PrimaryButton>
            </form>
          </Box>
        </ModalPopup>
      </Grid>
      {/* <LoaderBackdrop open={isLoading} /> */}
    </Grid>
  );
};

export default Withdraw;
